export default __webpack_public_path__ + "static/media/deer_grayscale.a8b89a4d.svg";